import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: Record<string, LayoutComponent> = {
  "7:1": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/sum-of-modes/pressure-modulus-650-1-mode.png`,
        },
      },
    },
  },
  "7:2": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/sum-of-modes/pressure-modulus-650-2-modes.png`,
        },
      },
    },
  },
  "7:3": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/sum-of-modes/pressure-modulus-650-3-modes.png`,
        },
      },
    },
  },
  "7:4": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/sum-of-modes/pressure-modulus-650-4-modes.png`,
        },
      },
    },
  },
  "7:5": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/sum-of-modes/pressure-modulus-650-5-modes.png`,
        },
      },
    },
  },
  "7:6": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/sum-of-modes/pressure-modulus-650-6-modes.png`,
        },
      },
    },
  },
  "7:7": {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/19/principle/sum-of-modes/pressure-modulus-650-7-modes.png`,
        },
      },
    },
  },
};

export default components;
